<template>
  <div class="container">
    <div class="postojece-container">
      <div class="outer-circle">
        <div class="inner-circle">
          <img
            :src="
              require('../../assets/images/konstrukcija/desktop_pozicije/' +
                ('' + current_position).padStart(2, '0') +
                '_icon.svg')
            "
            alt=""
          />
        </div>
      </div>

      <div class="left">
        <div class="title">
          {{ main_data.pos_position_from.select[current_position] }}
        </div>
        <template v-if="current_position != 10 && current_position != 13">
          <div class="image">
            <img
              :src="main_data.app_sklopovi_a.images[main_data.pos_status.value[current_position].top_image]"
              alt=""
            />
          </div>
          <div class="subtitle">
            {{ main_data.app_sklopovi_a.title[main_data.pos_status.value[current_position].top_image] }}
            <span v-if="development" style="color: red;">
              {{ main_data.pos_status.value[current_position].top_image.substr(1) }}&nbsp;
            </span>
            <span v-if="development" style="color: yellow;">
              {{ "u = " + app_math.numberWithCommas(get_pos_status_u[current_position].top.current) }}
            </span>
          </div>
          <div class="description">
            {{ main_data.app_sklopovi_a.select[main_data.pos_status.value[current_position].top_image] }}
          </div>
          <div class="spacer"></div>
          <div
            v-if="
              get_sklopovi_data.debljina_zida[main_data.pos_status.value[current_position].top_image] &&
              get_sklopovi_data.debljina_zida[main_data.pos_status.value[current_position].top_image].length > 1
            "
            class="row"
          >
            <div class="row-left">{{ main_data.pos_thickness.title }}</div>
            <div class="row-right">
              <!-- Odabir debljine zida -->
              <vue-select
                :design="{ color: '#82c964' }"
                :data="{
                  data: get_sklopovi_data.debljina_zida[main_data.pos_status.value[current_position].top_image],
                  value: main_data.pos_status.value[current_position].top_debljina_zida * 100,
                  text: get_sklopovi_data.debljina_zida[main_data.pos_status.value[current_position].top_image],
                  isInteger: true,
                }"
                unit="cm"
                @vue-select-change="value_change_new('top_debljina_zida', $event)"
              ></vue-select>
            </div>
          </div>
          <div
            class="row"
            v-if="
              main_data.app_sklopovi_a.data[main_data.pos_status.value[current_position].top_image].ima_termoizolaciju
            "
          >
            <div class="row-left">{{ main_data.pos_current_insulation.title }}</div>
            <div class="row-right">
              <!-- Odabir debljine postojece izolacije -->
              <vue-select
                :design="{ color: '#82c964' }"
                :data="{
                  data: Array(31)
                    .fill()
                    .map((x, i) => i)
                    .slice(1),
                  value: main_data.pos_status.value[current_position].top_debljina_izolacije * 100,
                  text: Array(31)
                    .fill()
                    .map((x, i) => i)
                    .slice(1),
                  isInteger: true,
                }"
                unit="cm"
                @vue-select-change="value_change_new('top_debljina_izolacije', $event)"
              ></vue-select>
            </div>
          </div>
        </template>
        <template v-else>
          <img class="vrata-prozor" v-if="current_position == 10" src="../../assets/images/windows_black.svg" alt="" />
          <img class="vrata-prozor" v-if="current_position == 13" src="../../assets/images/doorway_black.svg" alt="" />
        </template>
      </div>
      <div class="right">
        <template v-if="current_position != 10 && current_position != 13">
          <perfect-scrollbar class="picker">
            <div
              v-for="(item, index) in sklop_order"
              class="item"
              :key="'ps' + index"
              @click="value_change_new('top_image', item)"
            >
              <div
                :class="{ 'item-top': true, active: item === main_data.pos_status.value[current_position].top_image }"
              >
                <img
                  v-if="item === main_data.pos_status.value[current_position].top_image"
                  class="stikla"
                  src="../../assets/images/desktop/stikla_bela.svg"
                />
                <img :src="main_data.app_sklopovi_a.images[item]" alt="" />
              </div>
              <div
                :class="{
                  'item-bottom': true,
                  active: item === main_data.pos_status.value[current_position].top_image,
                }"
              >
                {{ (index + 1).toString().padStart(2, "0") }}
              </div>
            </div>
          </perfect-scrollbar>
        </template>
        <template v-else>
          <div class="vrata-prozor-top">
            <div :class="{ active: vrata_prozor_status == 1 }" @click="vrata_prozor_status = 1">
              {{ uppercase(main_data.pos_window.select[1]) }}
            </div>
            <div :class="{ active: vrata_prozor_status == 0 }" @click="vrata_prozor_status = 0">
              {{ uppercase(main_data.pos_window.select[0]) }}
            </div>
            <div :class="{ active: vrata_prozor_status == 2 }" @click="vrata_prozor_status = 2">
              {{ uppercase(main_data.pos_window.select[2]) }}
            </div>
          </div>
          <div class="vrata-prozor-list">
            <perfect-scrollbar class="scroller">
              <div
                class="row"
                v-for="item in filter_top_windows"
                :key="'vrata_prozor' + item"
                @click="$emit('set-status-data', { value: current_position, top_image: item })"
              >
                <div class="kockica">
                  <div class="inner" v-if="main_data.pos_status.value[current_position].top_image == item"></div>
                </div>
                <span>
                  <span> {{ `${main_data.app_sklopovi_a.title[item]}` }}</span
                  >&nbsp;
                  <span style="white-space: nowrap;"
                    >{{ `(U=${main_data.app_sklopovi.data[item].u} W/` }}m<sup>2</sup>K)</span
                  >
                </span>
              </div>
            </perfect-scrollbar>
          </div>
        </template>
        <div class="spacer"></div>
        <div class="button" @click="$emit('confirm-step', 5)">
          {{ main_data.pos_confirm.title }}
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.ps__thumb-x,
.ps__thumb-y {
  background-color: #24c46c !important;
}

.ps .ps__rail-x:hover,
.ps .ps__rail-y:hover,
.ps .ps__rail-x:focus,
.ps .ps__rail-y:focus,
.ps .ps__rail-x.ps--clicking,
.ps .ps__rail-y.ps--clicking {
  background-color: transparent !important;
}
</style>
<style lang="scss" scoped>
.container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;

  .postojece-container {
    width: 91rem;
    height: 67rem;
    color: $text_white;
    background-color: $main_header_middle;
    padding: 2.6rem 3.5rem 4rem 4.4rem;
    display: flex;
    justify-content: space-between;
    position: relative;
    border-radius: 5.3rem;

    .outer-circle {
      position: absolute;
      width: 12.2rem;
      height: 12.2rem;
      top: -3.3rem;
      left: -3.3rem;
      background-color: rgba(36, 196, 108, 0.51);
      border-radius: 50%;

      .inner-circle {
        position: absolute;
        width: 8.4rem;
        height: 8.4rem;
        top: calc(50% - 4.2rem);
        left: calc(50% - 4.2rem);
        background-color: $desktop-green;
        border-radius: 50%;
        z-index: 1;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          width: 120%;
          max-width: 120%;
          max-height: 120%;
        }
      }
    }

    .left {
      width: 34rem;
      display: flex;
      flex-direction: column;
      text-align: center;

      .title {
        font-family: F-Dem;
        font-size: 2.2rem;
        line-height: 1.32;
        color: $text_white;
        padding: 0 5rem;
      }

      .image {
        img {
          width: 80%;
          max-width: 80%;
          margin-top: -2rem;
        }
      }

      .subtitle {
        font-family: F-Dem;
        font-size: 2.8rem;
        line-height: 1.14;
        margin-bottom: 2rem;
      }

      .description {
        font-size: 1.8rem;
        line-height: 1.22;
        color: $desktop_text_inactive;
      }

      .spacer {
        flex-grow: 1;
      }

      .row {
        height: 3.5rem;
        display: flex;
        align-items: center;
        justify-content: space-between;

        &:not(:last-of-type) {
          margin-bottom: 1.3rem;
        }

        .row-left {
          margin-right: 1rem;
          font-size: 1.8rem;
          text-align: left;
        }

        .row-right {
          width: 9.7rem;
        }
      }

      .vrata-prozor {
        height: 31rem;
        width: auto;
        max-height: 31rem;
        margin-top: 8rem;
      }
    }

    .right {
      width: 42rem;
      display: flex;
      flex-direction: column;
      text-align: center;

      .picker {
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        min-height: 50rem;
        overflow-x: auto;
        flex: 1 1 1%;

        .item {
          width: 14.2rem;
          cursor: pointer;

          .item-top {
            height: 14.2rem;
            border-radius: 50%;
            position: relative;

            &.active {
              background-color: $desktop_button_inactive;
            }

            .stikla {
              position: absolute;
              z-index: 1;
              top: 0.5rem;
              right: 0.5rem;
              width: 4rem;
              height: 4rem;
            }

            img {
              width: 100%;
              max-width: 100%;
              max-height: 100%;
            }
          }

          .item-bottom {
            font-size: 1.4rem;
            line-height: 1.29;
            color: $desktop_button_text_inactive;
            text-align: center;

            &.active {
              color: $text_white;
            }
          }
        }
      }

      .spacer {
        flex-grow: 1;
      }

      .button {
        width: 100%;
        height: 7.3rem;
        border-radius: 3.65rem;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 2.4rem;
        line-height: 1.17;
        color: $text_white;
        background-color: $desktop_green;
        cursor: pointer;
      }

      .vrata-prozor-top {
        display: flex;
        align-content: center;
        justify-content: center;
        margin-top: 1.7rem;

        div {
          width: 13rem;
          font-family: F-Dem;
          font-size: 2.2rem;
          line-height: 1.32;
          text-align: center;
          color: $desktop_text_inactive;
          padding-bottom: 1.2rem;
          border-bottom: 2px solid $desktop_text_inactive;
          cursor: pointer;

          &.active {
            color: $desktop_green;
            border-bottom: 2px solid $desktop_green;
          }

          &:not(:last-child) {
            margin-right: 0.8rem;
          }
        }
      }

      .vrata-prozor-list {
        font-size: 2rem;
        line-height: 0.85;
        letter-spacing: normal;
        text-align: left;
        color: $text_white;
        padding-top: 3.5rem;
        margin-bottom: 3.5rem;
        flex-shrink: 1;

        .scroller {
          max-height: 40rem;

          .row {
            min-height: 2.4rem;
            display: flex;
            align-items: center;
            cursor: pointer;

            &:not(:last-child) {
              margin-bottom: 2.2rem;
            }

            .kockica {
              height: 2.4rem;
              width: 2.4rem;
              border-radius: 0.4rem;
              flex-shrink: 0;
              margin-right: 2rem;
              background-color: $desktop_text_inactive;
              display: flex;
              align-items: center;
              justify-content: center;

              .inner {
                height: 1.4rem;
                width: 1.4rem;
                background-color: $desktop_green;
              }
            }
          }
        }
      }
    }
  }
}
</style>
<style src="vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css"></style>

<script>
import helpers from "../../lib/helpers.js";
import select from "../../components/select.vue";
import app_math from "../../lib/math.js";
import mixin from "../../lib/mixins.js";
import superconsole from "../../lib/superconsole.js";
import settings from "../../Settings.js";
import { PerfectScrollbar } from "vue2-perfect-scrollbar";
import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";

export default {
  mixins: [mixin],
  props: ["main_data", "current_position", "get_sklopovi_data", "get_loc_u_max", "get_povrsine", "get_pos_status_u"],
  components: {
    "vue-select": select,
    PerfectScrollbar,
  },
  data: function () {
    return {
      app_math: app_math,
      vrata_prozor_status: 1,
      development: settings.develop,
    };
  },
  computed: {
    top_image_default: function () {
      if (this.main_data.typ_ceiling.value == 1) {
        return this.main_data.pos_status.value[this.current_position].top_image_default;
      } else {
        const def = this.main_data.pos_status.value[this.current_position].top_image_default;
        const splits = def.split("_");
        return "_" + splits[1] + "_" + (+splits[2] + 100);
      }
    },
    sklop_order: function () {
      let sklopovi = this.get_sklopovi_data.sklopovi[this.current_position];
      if (this.current_position == 18) {
        if (this.main_data.typ_ceiling.value == 1) {
          sklopovi = sklopovi.filter((x) => x.split("_")[2] <= 100);
        } else {
          sklopovi = sklopovi.filter((x) => x.split("_")[2] > 100);
        }
      }
      const index = sklopovi.findIndex((elem) => elem === this.top_image_default);
      return sklopovi.slice(index).concat(sklopovi.slice(0, index));
    },
    filter_top_windows: function () {
      return this.get_sklopovi_data.sklopovi[this.current_position].filter(
        (elem) =>
          helpers.get_top_sklop_data(this.main_data.app_sklopovi.data, elem).tip_prozora === this.vrata_prozor_status
      );
    },
  },
  methods: {
    value_change_new: function (name, value) {
      if (name === "pos_nagib") {
        this.valuechange("pos_nagib", value);
        this.set_values("bottom_debljina_izolacije", {});
      } else if (name === "top_image") {
        this.set_values("top_image", { image: value });
      } else if (name === "top_debljina_zida") {
        this.set_values("top_debljina_zida", { debljina_zida: value });
      } else if (name === "top_debljina_izolacije") {
        this.set_values("top_debljina_izolacije", { debljina_izolacije: value });
      }
    },
    set_values: function (type, value) {
      const res = app_math.calculate_status_change(
        type,
        value,
        this.current_position,
        this.main_data.app_sklopovi,
        this.get_sklopovi_data,
        this.main_data.app_sklopovi_a,
        this.main_data.app_sklopovi_b,
        this.main_data.app_sklopovi_c,
        this.main_data.pos_standard,
        this.get_loc_u_max,
        this.main_data.pos_status,
        this.main_data.typ_dubina,
        this.main_data.typ_vrstatla,
        this.get_povrsine
      );
      superconsole.log(res);
      for (const key of Object.keys(res.emit_status)) {
        this.emit_status(key, res.emit_status[key]);
      }
    },
    emit_status: function (prop, value) {
      let event = { value: this.current_position };
      event[prop] = value;
      this.$emit("set-status-data", event);
    },
    valuechange: function (name, value, isnumber) {
      if (isnumber) {
        value = +value;
      }
      this.$emit("value-change", {
        name: name,
        value: value,
      });
    },
  },
  mounted: function () {
    this.set_values("default");
    if (this.current_position == 10 || this.current_position == 13) {
      this.vrata_prozor_status = this.main_data.app_sklopovi.data[
        this.main_data.pos_status.value[this.current_position].top_image
      ].tip_prozora;
    }
  },
};
</script>
